import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import './App.scss';
import './framework.scss';

export default function ThemeManager(props) {
  const dispatch = useDispatch();
  const redux = useSelector((state) => state.redux);
  // A custom theme for this app
  const themeState = redux.app.default_theme;
  const palletType = themeState == 'dark' ? 'dark' : 'light';
  const mainPrimaryColor = themeState == 'dark' ? '#A20016' : '#A20016';
  const mainSecondaryColor = themeState == 'dark' ? '#f02849' : '#f02849';

  const R = 24; // 1.5rem if your html font-size = 16px

  const theme = createTheme({
    typography: {
      fontFamily: 'Outfit, Arial, sans-serif',
    },
    palette: {
      type: palletType,
      primary: { main: mainPrimaryColor },
      secondary: { main: mainSecondaryColor },
    },
    shape: {
      borderRadius: R, // default radius for many components
    },
    props: {
      // ensure Papers/Dialogs/Menus actually use rounded corners
      MuiPaper: { square: false },
    },
    overrides: {
      MuiButton: {
        root: { borderRadius: R },
      },
      MuiCard: {
        root: { borderRadius: R, overflow: 'hidden' }, // overflow helps images respect radius
      },
      MuiTextField: {
        root: { borderRadius: R }, // visual only; real border is on OutlinedInput
      },
      MuiOutlinedInput: {
        root: { borderRadius: R },
        notchedOutline: { borderRadius: R }, // important for outlined variant
      },
      MuiPaper: {
        rounded: { borderRadius: R }, // affects Paper with square={false}
      },
      MuiList: {
        root: { borderRadius: R },
      },
      // v4 uses ListItem (with prop `button`) — not ListItemButton
      MuiListItem: {
        root: { borderRadius: R },
      },
      // Menus/Dialogs/Popovers: target their Paper slot
      MuiMenu: {
        paper: { borderRadius: R },
      },
      MuiDialog: {
        paper: { borderRadius: R },
      },
      MuiPopover: {
        paper: { borderRadius: R },
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {props.children}
    </ThemeProvider>
  );
}
